/*
  The steps the onboarding runs, by card. The import has none: having a club
  is what makes it done.
*/
export const ONBOARDING_STEP_FEATURES = {
    showBest: "MY_CLUB_ONBOARDING_SHOW_BEST",
    recommendations: "MY_CLUB_ONBOARDING_RECOMMENDATIONS",
    sbc: "MY_CLUB_ONBOARDING_SBC",
    gallery: "MY_CLUB_ONBOARDING_GALLERY",
    liveEvent: "MY_CLUB_ONBOARDING_LIVE_EVENT",
    // The evolution step is left out for now.
    // evolution: "MY_CLUB_ONBOARDING_EVOLUTION",
    budget: "MY_CLUB_ONBOARDING_BUDGET",
    profit: "MY_CLUB_ONBOARDING_PROFIT",
    // The setup step is left out for now.
    // setup: "MY_CLUB_ONBOARDING_SETUP",
};
/** Import, then one step per feature above. */
export const ONBOARDING_TOTAL = 1 + Object.keys(ONBOARDING_STEP_FEATURES).length;
/** How many steps are done: the import, plus every step the account ticked. */
export const onboardingDone = (usedFeatures = []) => 1 +
    Object.values(ONBOARDING_STEP_FEATURES).filter((step) => usedFeatures.includes(step)).length;
//# sourceMappingURL=onboarding.js.map